import type { EditorPlugin } from '../../types/aha-editor';
import { type Editor, type NodeEntry, Transforms } from 'slate';
import { isCodeBlockElement } from '../../types/guards';
import BlockFormatNormalizationsPluginFactory from '../Blocks/BlockFormatNormalizationsPluginFactory';

const CodeBlockNormalizationsPlugin: EditorPlugin[] = [
  {
    name: 'Code Block Normalizations',
    normalizations: [
      {
        check: (_: Editor, [node]: NodeEntry) => {
          return !isCodeBlockElement(node) && 'code_language' in node;
        },
        run: (editor: Editor, nodeEntry: NodeEntry) => {
          Transforms.setNodes(
            editor,
            {
              code_language: undefined,
            },
            {
              at: nodeEntry[1],
            }
          );
          return true;
        },
      },
    ],
  },
  BlockFormatNormalizationsPluginFactory('code'),
];

export default CodeBlockNormalizationsPlugin;
